import { defineNuxtRouteMiddleware, navigateTo } from "#imports";
import publicPaths from "~/data/sitemapRoutes.json";

// Ajoute ici la même logique de patterns publics (idéalement factorise avec ton auth.js)
const publicPatterns = [
  /^\/$/, // Accueil
  /^\/courses$/,
  /^\/course\/[^/]+$/, // Tous les cours (liste + détail)
  /^\/articles$/,
  /^\/article\/[^/]+$/,
  /^\/cart$/,
  /^\/cart\/?$/,
  /^\/books$/,
  /^\/book\/[^/]+$/,
  /^\/contribute$/,
  /^\/404$/,
  /^\/403$/,
  /^\/verify-email$/,
  /^\/crafts$/,
  /^\/craft\/[^/]+$/,
  /^\/stationeries$/,
  /^\/stationery\/[^/]+$/,
  /^\/clothings$/,
  /^\/clothing\/[^/]+$/,
  /^\/shop$/,
  /^\/shop\/?[^/]*$/, // Shop et variations (shop/checkout/...)
  /^\/contact$/,
  /^\/documentation(\/.*)?$/, // Toute la doc et ses sous-pages
  /^\/privacy$/,
  /^\/terms$/,
  /^\/login$/,
  /^\/register\/?[^/]*$/,
  /^\/forgot-password$/,
  /^\/reset-password$/,
  /^\/lesson\/[^/]+$/, // Leçons publiques simples
  /^\/lesson\/.*$/, // Leçons publiques complexes (virtual-keyboard, exercises, etc.)
  /^\/category\/[^/]+$/, // Catégories publiques
  /^\/services(\/.*)?$/, // Toutes les pages de services
  /^\/payment-success$/, // Page de confirmation paiement
  // ... ajoute ici tout ce que tu veux explicitement en public
];

export default defineNuxtRouteMiddleware((to) => {
  // Autoriser toutes les routes publiques
  if (
    publicPaths.includes(to.path) ||
    publicPatterns.some((pattern) => pattern.test(to.path))
  ) {
    return;
  }

  const auth = useAuthStore();
  if (!auth.isLoggedIn && to.path !== "/login") {
    return navigateTo("/login");
  }
});
